import axios from "axios";
import authHeader from "./auth-header";
import msGraphAuthHeader from "./ms-graph-auth-header";

// import * as msal from "@azure/msal-browser";
import { msalInstance } from "vue-msal-browser";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/api/meeting/`;
// console.log(API_URL);
class MeetingService {
  async all() {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios.get(API_URL + "all", { headers: headers }).then(response => {
      return response.data;
    });
  }

  async item(id) {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios.get(API_URL + id, { headers: headers }).then(response => {
      return response.data;
    });
  }
  async update(meeting) {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios.post(API_URL, meeting, { headers: headers }).then(response => {
      return response.data;
    });
  }

  async remove(_id) {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios.delete(API_URL + _id, { headers: headers }).then(response => {
      return response.data;
    });
  }

  addParticipant(_id, roomNo) {
    const obj = {
      roomNo: roomNo,
    };
    return axios
      .post(`${API_URL}${_id}/participants`, obj, {
        headers: authHeader(),
      })
      .then(response => {
        return response.data;
      });
  }

  clearParticipant(_id) {
    return axios
      .delete(`${API_URL}${_id}/participants`, { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }

  getParticipants(_id) {
    return axios
      .get(`${API_URL}${_id}/participants`, { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }

  async teamsMessageTemplates(_id) {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios
      .get(`${API_URL}${_id}/teams-message-templates`, {
        headers: headers,
      })
      .then(response => {
        return response.data;
      });
  }

  async sendTeamsMessage(_id, teamsMessageTemaplate, message) {
    let headers = authHeader();
    let account = msalInstance.getActiveAccount();
    if (account) {
      let tmp = await msGraphAuthHeader();
      headers["ms-graph-authorization"] = tmp.accessToken;
      headers["ms-graph-account-id"] = tmp.account.homeAccountId;
    }
    return axios
      .post(
        `${API_URL}${_id}/teams-message`,
        {
          message: message,
          teamsMessageTemaplate: teamsMessageTemaplate,
        },
        {
          headers: headers,
        },
      )
      .then(response => {
        return response.data;
      });
  }
}

export default new MeetingService();
